import { SourceMetadata } from '@lib.core/entities/indicator/source-metadata';

export class SourceMetadataDTO {
  sourceId!: number;
  geoTypes!: string[];

  static toSourceMetadata(sourceMetadataDTO: SourceMetadataDTO) {
    const { sourceId, geoTypes } = sourceMetadataDTO;
    return new SourceMetadata(sourceId, geoTypes);
  }
}
